/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuSection } from '../../models/menu-section';

export interface CreateMenuSection$Params {
      body: MenuSection
}

export function createMenuSection(http: HttpClient, rootUrl: string, params: CreateMenuSection$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuSection>> {
  const rb = new RequestBuilder(rootUrl, createMenuSection.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuSection>;
    })
  );
}

createMenuSection.PATH = '/admin/menu';
